import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Grid,
  Card,
  CardContent
} from '@mui/material';

const SkillsView = ({ skills = [] }) => {
  if (!skills || skills.length === 0) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>Skills</Typography>
        <Typography variant="body2" color="text.secondary">
          No skills added yet.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>Skills</Typography>
      
      <Grid container spacing={2}>
        {skills.map((skillCategory) => (
          <Grid item xs={12} sm={6} md={4} key={skillCategory.id}>
            <Card>
              <CardContent>
                <Box>
                  <Typography variant="h6" gutterBottom>
                    {skillCategory.category}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{ whiteSpace: 'pre-wrap' }}
                  >
                    {skillCategory.skills}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default SkillsView; 